import Profile from './contrainers/ProfileContainer';

export default Profile;
